import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Learn', href: '#learn' },
    { label: 'Tools', href: '#tools' },
    { label: 'Projects', href: '#projects' },
    { label: 'Forum', href: '#forum' },
    { label: 'Jobs', href: '#jobs' },
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <span className="logo-rails">RAILS</span>
            <span className="logo-separator">by</span>
            <span className="logo-dx">DX</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            {navLinks.map((link) => (
              <a key={link.label} href={link.href} className="nav-link">
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="header-cta">
            <Button 
              className="join-button"
              onClick={() => {
                const ctaSection = document.getElementById('cta-join');
                ctaSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Join Community
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-menu">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="mobile-nav-link"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <Button 
              className="mobile-join-button" 
              onClick={() => {
                setIsMobileMenuOpen(false);
                const ctaSection = document.getElementById('cta-join');
                ctaSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Join Community
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
